<script lang="ts">
  export let name: keyof typeof icons;

  interface Icons {
    [x: string]: {
      inner: string;
    };
  }

  const icons = {
    show: {
      inner: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 306 306"  xml:space="preserve"><g id="expand-more"><polygon points="270.3,58.65 153,175.95 35.7,58.65 0,94.35 153,247.35 306,94.35"/></g></svg>`,
    },
    add: {
      inner: `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 7 7" fill="none">
      <path d="M3.5 0C1.56695 0 0 1.56695 0 3.5C0 5.43305 1.56695 7 3.5 7C5.43305 7 7 5.43305 7 3.5C7 1.56695 5.43305 0 3.5 0ZM4.9 3.85H3.85V4.9C3.85 5.0932 3.6932 5.25 3.5 5.25C3.3068 5.25 3.15 5.0932 3.15 4.9V3.85H2.1C1.9068 3.85 1.75 3.6932 1.75 3.5C1.75 3.3068 1.9068 3.15 2.1 3.15H3.15V2.1C3.15 1.9068 3.3068 1.75 3.5 1.75C3.6932 1.75 3.85 1.9068 3.85 2.1V3.15H4.9C5.0932 3.15 5.25 3.3068 5.25 3.5C5.25 3.6932 5.0932 3.85 4.9 3.85Z" fill="black"/>
      </svg>`,
    },
    add_b: {
      inner: `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path d="M11.0833 7.58342H7.58329V11.0834H6.41663V7.58342H2.91663V6.41675H6.41663V2.91675H7.58329V6.41675H11.0833V7.58342Z" fill="black"/>
      </svg>`,
    },
    close: {
      inner: `<svg xmlns="http://www.w3.org/2000/svg" width="5" height="5" viewBox="0 0 5 5" fill="none">
      <path d="M5 0.503571L4.49643 0L2.5 1.99643L0.503571 0L0 0.503571L1.99643 2.5L0 4.49643L0.503571 5L2.5 3.00357L4.49643 5L5 4.49643L3.00357 2.5L5 0.503571Z" fill="black"/>
      </svg>`,
    },
    code: {
      inner: `<svg enable-background="new 0 0 522.468 522.469" version="1.1" viewBox="0 0 522.47 522.47" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"><path d="m325.76 70.513-17.706-4.854c-2.279-0.76-4.524-0.521-6.707 0.715-2.19 1.237-3.669 3.094-4.429 5.568l-106.49 368.59c-0.76 2.475-0.522 4.809 0.715 6.995 1.237 2.19 3.09 3.665 5.568 4.425l17.701 4.856c2.284 0.766 4.521 0.526 6.71-0.712 2.19-1.243 3.666-3.094 4.425-5.564l106.5-368.59c0.759-2.474 0.523-4.808-0.716-6.999-1.238-2.19-3.089-3.665-5.564-4.424z"/>
      <path d="m166.17 142.46c0-2.474-0.953-4.665-2.856-6.567l-14.277-14.276c-1.903-1.903-4.093-2.857-6.567-2.857s-4.665 0.955-6.567 2.857l-133.04 133.04c-1.906 1.903-2.856 4.093-2.856 6.567s0.953 4.664 2.856 6.566l133.04 133.04c1.902 1.906 4.089 2.854 6.567 2.854s4.665-0.951 6.567-2.854l14.277-14.268c1.903-1.902 2.856-4.093 2.856-6.57 0-2.471-0.953-4.661-2.856-6.563l-112.2-112.21 112.2-112.2c1.906-1.902 2.856-4.093 2.856-6.567z"/>
      <path d="m519.61 254.66-133.05-133.04c-1.902-1.902-4.093-2.857-6.563-2.857-2.478 0-4.661 0.955-6.57 2.857l-14.271 14.275c-1.902 1.903-2.851 4.09-2.851 6.567s0.948 4.665 2.851 6.567l112.21 112.2-112.21 112.21c-1.902 1.902-2.851 4.093-2.851 6.563 0 2.478 0.948 4.668 2.851 6.57l14.271 14.268c1.909 1.906 4.093 2.854 6.57 2.854 2.471 0 4.661-0.951 6.563-2.854l133.05-133.04c1.903-1.902 2.854-4.096 2.854-6.57 0-2.475-0.951-4.665-2.854-6.567z"/></svg>`,
    },
    arrow_back: {
      inner: `<svg xmlns="http://www.w3.org/2000/svg" height="24" width="24"><path d="M12 19.625 4.375 12 12 4.375l1.075 1.075-5.825 5.8h12.375v1.5H7.25l5.825 5.8Z"/></svg>`,
    },
  } as Icons;
</script>

{@html icons[name].inner}
